import { render, staticRenderFns } from "./management-calculation-history-content-component.vue?vue&type=template&id=2c4bd980&scoped=true&"
import script from "./management-calculation-history-content-component.vue?vue&type=script&lang=ts&"
export * from "./management-calculation-history-content-component.vue?vue&type=script&lang=ts&"
import style0 from "./management-calculation-history-content-component.vue?vue&type=style&index=0&id=2c4bd980&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bd980",
  null
  
)

export default component.exports